// removed by extract-text-webpack-plugin
module.exports = {"content":"FollowUp90Day__content__3QfZ_","parentContainer":"FollowUp90Day__parentContainer__1rh5O","searchWrapper":"FollowUp90Day__searchWrapper__2Qikg","searchWrapperLabel":"FollowUp90Day__searchWrapperLabel__1NjiQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FollowUp90Day/FollowUp90Day.css
// module id = 1840
// module chunks = 0